import { saveToken, saveUser, saveServiceTypes, clearAuthData } from '../utils/storageUtils';

export const initialState = {
    isLoading: false,
    loginError: '',
    isLoggedIn: false,
    loggedInUser: null,
    userType: '',
    serviceTypes: [],
    jwtToken: '',
    userMembership: {
        groups: [],
        rooms: [],
        totalJoined: 0
    },
};

export const LoginReducer = (state = initialState, action) => {
    
    switch(action.type){
        case 'field': {
            return {
                ...state,
                [action.fieldName]: action.payload,
            };
        }
        case 'login': {
            return {
                ...state,
                loginError: '',
                isLoading: true,
            };
        }
        case 'loginSuccess': {
            return {
                ...state,
                isLoggedIn: true,
                isLoading: false,
                loggedInUser: action.payload,
            };
        }
        case 'error': {
            return {
                ...state,
                loginError: action.payload,
                isLoggedIn: false,
                isLoading: false,
            };
        }
        case 'clearError': {
            return {
                ...state,
                loginError: '',
                isLoading: false,
            };
        }
        case 'logout': {
            // Clear localStorage on logout
            clearAuthData();
            return {
                ...state,
                isLoggedIn: false,
                loggedInUser: null,
                loginError:'',
                isLoading: false,
                jwtToken:'',
            };
        }
        case 'populateServiceTypes': {
            saveServiceTypes(action.payload);
            return {
                ...state,
                serviceTypes: action.payload,
            };
        }
        case 'setJwtToken': {
            saveToken(action.payload);
            return {
                ...state,
                jwtToken: action.payload,
            }
        }
        case 'setLoggedInUser': {
            saveUser(action.payload);
            return {
                ...state,
                loggedInUser: action.payload,
            }
        }
        case 'setUserMembership': {
            return {
                ...state,
                userMembership: action.payload,
            }
        }
        case 'hydrateFromStorage': {
            return {
                ...state,
                ...action.payload,
            }
        }
        default: 
            return state

    }
    
    
};